var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixedTestTubes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99505 1.5L0.509766 9.98527V11.3995H1.92397L11.8235 21.2991C13.3856 22.8612 15.9183 22.8612 17.4804 21.2991L20.3088 18.4707C21.8709 16.9086 21.8709 14.3759 20.3088 12.8138L10.4093 2.91422V1.5H8.99505ZM3.33823 9.98536L8.99509 4.3285L18.8946 14.228C19.6756 15.009 19.6756 16.2755 18.8946 17.0565L16.0662 19.8849C15.2851 20.666 14.0188 20.666 13.2377 19.8849L3.33823 9.98536Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91006 13.7983C2.12706 15.3053 2.36787 17.206 3.6325 18.4705L6.46094 21.2991C7.72559 22.5637 9.62634 22.8045 11.1332 22.0215C11.1281 22.0164 11.123 22.0113 11.1179 22.0062L9.56355 20.4519C8.96466 20.5342 8.33559 20.3453 7.87515 19.8848L5.04672 17.0564C4.58629 16.596 4.39728 15.9669 4.4797 15.368L2.91006 13.7983ZM10.5497 20.0238L11.825 21.2991C11.8729 21.3469 11.9217 21.3935 11.9714 21.4383C12.021 21.3935 12.0699 21.3469 12.1178 21.2991L12.493 20.9238L11.1276 19.4608L10.7036 19.8848C10.6541 19.9343 10.6028 19.9806 10.5497 20.0238ZM21.1608 12.2561L22.0173 11.3995H23.4317L23.4315 9.98529L14.9463 1.5H13.5321V2.91422L12.6785 3.76779L14.0927 5.18199L14.9462 4.32847L20.6031 9.98533L19.7496 10.8389L21.0174 12.1067C21.0664 12.1557 21.1141 12.2055 21.1608 12.2561ZM19.0425 11.546L20.3103 12.8138C20.3594 12.8629 20.4069 12.9129 20.4529 12.9639L19.464 13.9528L18.0498 12.5386L19.0425 11.546ZM13.3856 5.88909L11.9714 4.47489L10.9788 5.46753L12.393 6.88173L13.3856 5.88909ZM3.48982 12.9639C3.53584 12.9129 3.58341 12.8629 3.6325 12.8137L4.22875 12.2175L5.64296 13.6317L5.04672 14.228C4.99729 14.2774 4.95097 14.3288 4.9078 14.3819L3.48982 12.9639Z",
    fill: "#3360AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80966 13.0424L14.9996 11.7471L18.187 14.9346C18.5776 15.3251 18.5776 15.9583 18.187 16.3489L15.3586 19.1773C14.9682 19.5677 14.335 19.5677 13.9445 19.1773L7.80966 13.0424Z",
    fill: "#208C72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixedTestTubes);
export default __webpack_public_path__ + "static/media/mixed-test-tubes.66244c43ff5580257858d58914b61414.svg";
export { ForwardRef as ReactComponent };